import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="merge-form"
export default class extends Controller {
  static targets = [
    "albumSelect",
    "nameSection",
    "nameInput",
    "nameLength",
    "namePreviewText",
    "previewAlbumName",
    "preview",
    "submitBtn",
    "totalImages",
    "totalCollaborators"
  ]

  static values = {
    sourceImagesCount: Number,
    sourceCollaboratorsCount: Number,
    sourceAlbumName: String
  }

  connect() {
    this.selectedTargetName = ''
    this.updateCharacterCount()
  }

  albumChanged() {
    const selectedOption = this.albumSelectTarget.options[this.albumSelectTarget.selectedIndex]

    if (this.albumSelectTarget.value) {
      // Show name input section and preview
      this.nameSectionTarget.classList.remove('hidden')
      this.previewTarget.classList.remove('hidden')
      this.submitBtnTarget.disabled = false

      // Store selected target name
      this.selectedTargetName = selectedOption.dataset.name

      // Update preview data
      const targetImagesCount = parseInt(selectedOption.dataset.imagesCount) || 0
      const targetCollaboratorsCount = parseInt(selectedOption.dataset.collaboratorsCount) || 0

      this.totalImagesTarget.textContent = this.sourceImagesCountValue + targetImagesCount
      this.totalCollaboratorsTarget.textContent =
        Math.max(this.sourceCollaboratorsCountValue, targetCollaboratorsCount) + ' (estimated)'

      // Update name preview
      this.updateNamePreview()
    } else {
      // Hide sections
      this.nameSectionTarget.classList.add('hidden')
      this.previewTarget.classList.add('hidden')
      this.submitBtnTarget.disabled = true
      this.selectedTargetName = ''
    }
  }

  nameInputChanged() {
    this.updateCharacterCount()
    this.updateNamePreview()
  }

  updateNamePreview() {
    const customName = this.nameInputTarget.value.trim()
    let displayName

    if (customName.length > 0) {
      displayName = customName
      this.namePreviewTextTarget.textContent = 'Custom name: '
    } else {
      // Generate default name
      if (this.selectedTargetName) {
        displayName = `${this.sourceAlbumNameValue} + ${this.selectedTargetName}`
        this.namePreviewTextTarget.textContent = 'Auto-generated: '
      } else {
        displayName = ''
        this.namePreviewTextTarget.textContent = ''
      }
    }

    if (displayName) {
      this.previewAlbumNameTarget.textContent = displayName
    }
  }

  updateCharacterCount() {
    const length = this.nameInputTarget.value.length
    this.nameLengthTarget.textContent = length

    // Remove all classes first
    this.nameLengthTarget.classList.remove('text-red-600', 'text-yellow-600')

    if (length > 120) {
      this.nameLengthTarget.classList.add('text-red-600')
    } else if (length > 100) {
      this.nameLengthTarget.classList.add('text-yellow-600')
    }
  }
}